import { Dispatch } from "redux";
import { loadAndTrack, isRequestActive } from "redux-request-loading";

import { Payload } from "@neworbit/redux-helpers";

import { ApplicationState } from "../../applicationState";

import * as actions from "./actiontypes";
import * as models from "./model";
import AdminUserApi from "./adminUserApi";
import { LOAD_ADMIN_USERS_WITH_TEAMS } from "./actiontypes";

export type AdminUsersWithTeamsAction =
    ({ type: typeof actions.LOAD_ADMINUSERS_WITH_TEAMS_SUCCESS } & Payload<models.AdminUserListModelWithTeams[]>);

export const loadAdminUsersWithTeamsSuccess = (payload: models.AdminUserListModelWithTeams[]): AdminUsersWithTeamsAction => ({
    payload,
    type: actions.LOAD_ADMINUSERS_WITH_TEAMS_SUCCESS
});

export function loadAdminUsersWithTeams(finished: boolean = false) {
    return async (dispatch: Dispatch, getState: () => ApplicationState) => {
        const isLoading = isRequestActive(getState(), LOAD_ADMIN_USERS_WITH_TEAMS);
        if (isLoading) {
            return;
        }

        const result = await loadAndTrack(dispatch, LOAD_ADMIN_USERS_WITH_TEAMS, AdminUserApi.getAllWithTeams(finished));
        dispatch(loadAdminUsersWithTeamsSuccess(result));
    };
}
